<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="venimpfac"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmarvenimpfac" title="Confirmar Acción"
				 appendTo="body"></p-confirmDialog>
<div class="p-grid" style="width: 98%">
	<div class="p-col-12">
		<app-invmaebarra [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
						 [barraBotones5]="true" [botonVisto]="false" [barraBotonesCRUD]="true" [barraBotones3Alt]="false"
						 (signal)="manejarSenales($event)" [botonExcelPermanente]="true"
						 style="text-align: left;">
		</app-invmaebarra>
	</div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            
                <div class="divgrups">
                    <div class="p-grid">
                        <div class="p-col-1">
                            <span>Servicio:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="SER_CODIGO"></label>
                            <input class="frm" id="SER_CODIGO" type="text" pInputText [disabled]="false"
                                [(ngModel)]="SER_CODIGO"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <button type="button"
                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                (click)="busquedaservicio(SER_CODIGO)"></button>
                        </div>
                        <div class="p-col-3">
                            <label for="SER_NOMBRE"></label>
                            <input class="frm" id="SER_NOMBRE" type="text" pInputText disabled
                                style="color: blue;"
                                [(ngModel)]="SER_NOMBRE"
                                autocomplete="off">
                        </div>
                
                    </div>
                   
                </div>
            
            <app-aggridsaci [width]="" [height]="80" [enableSorting]="true" [enableFilter]="true"
                [rowData]="vendetfacimp" [frameworkComponents]="frameworkComponents"
                [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsDetfacimp"
                [defaultColDef]="defaultDetfacimp" [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="false"
                [mostrarGuardar]="false"  [comboOpciones]="" [solobotoneliminar]="false"
                  (selected)="seleccionItem($event)" [tipodetalle]=""
                (cambios)="cambio($event)" [CC]="true">
            </app-aggridsaci>
            <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Facturas ya registradas en el sistema</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusqueda" [transitionOptions]="'0ms'" [modal]="false"
	appendTo="body" [style]="{width: '70vw', height: '70vh'} " [focusOnShow]="true">
	<!-- <app-invbusqueda [arrayOptions]="types" [arregloConsulta]="arregloCons"
		(opcionSeleccionada)="manejarSeleccion($event)"></app-invbusqueda> -->
        <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
        [consulta]="consulta"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>
<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
	<p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
	</p-progressSpinner>
</div>


<input  #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;"
			accept=".xls, .xlsx"
                (change)="onBasicUpload(inputFile.files)" />